import { User } from '@tools/ui/types';
import { Scalars, SherlockUser } from '@tools/ui/types/generated/graphql';
import {
  handleSuccessResponse,
  Response
} from '@tools/ui-utils/response-handling.util';
import { axios as api } from './api';

const routePrefix = '/users';

export const getCurrentUser = async (): Promise<User> => {
  return api.get(`${routePrefix}/getCurrentUser`);
};

export const getAllUsers = async (): Promise<User[]> => {
  return api.get(`${routePrefix}/getAllUsers`);
};

export const createUser = async (
  user: Partial<SherlockUser>
): Promise<Response> => {
  return api.post(`${routePrefix}`, user).then(handleSuccessResponse);
};

export const updateUser = async (
  user: Partial<SherlockUser>
): Promise<Response> => {
  return api.put(`${routePrefix}`, user).then(handleSuccessResponse);
};

export const deleteUser = async (
  userId: Scalars['MongoID']
): Promise<Response> => {
  return api
    .delete(`${routePrefix}`, { data: { _id: userId } })
    .then(handleSuccessResponse);
};
